import { GetCoachingProgramsQuery } from "@/graphql";

type Program = GetCoachingProgramsQuery["coachingPrograms"]["programs"][number];
type Session = Program["sessions"][number];
type CoachProduct = Program["coaches"][number]["coachProduct"];

export function findFirstAvailableSession(programs: Program[]): {
  session: Session | null;
  coachProduct: CoachProduct | null;
} {
  // Iterate through all programs in order
  for (const program of programs) {
    if (!program.isCoachInProgram) continue;

    const coach = program.coaches.find(
      (c) => !c.isBooked && !c.requiresSelection && c.isAvailable,
    );
    if (!coach) continue;

    const session = program.sessions.find((s) => s.id === coach.sessionId);
    if (!session) continue;

    return { session, coachProduct: coach.coachProduct };
  }

  return { session: null, coachProduct: null };
}
